import { create } from "zustand";
import { fetchWithAuth } from "../api/fetchWithAuth";
import { useProjectStore } from "./useProjectStore";
import { useAoiStore } from "./useAoiStore";

export const useRunsStore = create((set, get) => ({

  runs: [],
  loading: false,

  getActiveProjectId: () => {
    const { activeProjectId, projects } = useProjectStore.getState();
    const project = projects.find(
      p => p.slug === activeProjectId || p.id === activeProjectId
    );
    return project?.id || null;
  },

  //
  // LOAD RUNS (AI API)
  //
  loadRuns: async () => {
    const projectId = get().getActiveProjectId();
    if (!projectId) {
      set({ runs: [] });
      return;
    }

    set({ loading: true });

    try {
      const res = await fetchWithAuth(
        `/api/ai/projects/${projectId}/runs`
      );

      if (!res.ok) throw new Error(res.status);

      const data = await res.json();

      set({
        runs: Array.isArray(data) ? data : [],
        loading: false
      });

    } catch (err) {
      console.error("loadRuns failed", err);
      set({ loading: false });
    }
  },

  //
  // CREATE RUN
  //
  createRun: async ({ aoi_id, task_key, run_type }) => {
    const projectId = get().getActiveProjectId();
    if (!projectId) return null;

    // 🔹 Pull dataset from AOI store
    const { imageryCoverageByAoi } = useAoiStore.getState();
    const coverage = imageryCoverageByAoi[aoi_id];

    if (!coverage?.isEligible || !coverage?.selectedDatasetId) {
      console.error("Run blocked: AOI not eligible for AI execution");
      return null;
    }

    const dataset_id = coverage.selectedDatasetId;

    try {
      const res = await fetchWithAuth("/api/ai/runs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          project_id: projectId,
          aoi_id,
          dataset_id,
          task_key,
          run_type
        })
      });

      if (!res.ok) {
        console.error("createRun failed", await res.text());
        return null;
      }

      const run = await res.json();

      set(state => ({
        runs: [run, ...state.runs]
      }));

      return run;

    } catch (err) {
      console.error("createRun error", err);
      return null;
    }
  },

  resetForProjectChange: () => {
    set({ runs: [] });
  }

}));